"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalDiscount = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var discount_types_1 = require("../../types/discount.types");
var big_numbers_1 = require("../../utils/big-numbers");
var getGlobalDiscount = function (remises) {
    var _a = remises
        .filter(function (remise) { return remise.applyMethod === discount_types_1.APPLY_METHOD.RATE; })
        .reduce(function (_globalDiscount, remise) {
        _globalDiscount.discountedRate = _globalDiscount.discountedRate.multipliedBy(big_numbers_1.big1.minus(new bignumber_js_1.default(remise.amount).dividedBy(big_numbers_1.big10000)));
        if (remise.type === discount_types_1.DISCOUNT_TYPE.PROMOCODE) {
            _globalDiscount.promocode = {
                code: remise.label,
                value: remise.amount,
            };
        }
        return _globalDiscount;
    }, { discountedRate: big_numbers_1.big10000, promocode: null }), discountedRate = _a.discountedRate, globalDiscount = __rest(_a, ["discountedRate"]);
    return __assign({ discountRate: big_numbers_1.big10000.minus(discountedRate).integerValue().toNumber() }, globalDiscount);
};
exports.getGlobalDiscount = getGlobalDiscount;
